import { motion } from "framer-motion";
import { Star, Quote, MapPin } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const REVIEWS = [
  {
    name: "Lucas Almeida",
    city: "Barra Grande — BA",
    text: "Fiz o projeto e a execução com a HB Solar e em todas as etapas fui muito bem atendido. Todas as minhas dúvidas foram de pronto esclarecidas. A assistência que a empresa nos dá no pós-venda é de excelência. Estou super satisfeito com a HB Solar.",
  },
  {
    name: "Edinaldo Coelho",
    city: "Jequié — BA",
    text: "Experiência excelente. Instalação no padrão e dentro do prazo acordado. A eficiência das placas está de acordo com o que foi negociado. Empresa nota 10, recomendo.",
  },
  {
    name: "Caio Rocha",
    city: "Ipiaú — BA",
    text: "Ótimo atendimento, prazo e qualidade. Sempre à disposição.",
  },
  {
    name: "Tassio Franco",
    city: "Teixeira de Freitas — BA",
    text: "Atendimento muito bom. Apesar da distância, foram bem atenciosos passando todas as informações sobre equipamentos, orçamento, entrega e instalação. Após o fechamento, o equipamento chegou em uma semana; instalaram, testaram e em 5 dias corridos a Coelba já estava com tudo funcionando! Super recomendo! Preço justo, equipamentos de alta qualidade e atendimento top.",
  },
];

const initials = (name) =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0])
    .join("");

export const Testimonials = () => (
  <section
    id="depoimentos"
    data-testid="testimonials-section"
    className="relative py-24 lg:py-32 bg-[#FAFAF9]"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="max-w-3xl"
      >
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-amber-500 mb-4">
          Quem já fez a troca
        </p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight text-[#0B192C]">
          Quem instalou com a HB Solar,{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-500 to-amber-600">
            recomenda
          </span>
        </h2>
      </motion.div>

      <div className="mt-14 grid sm:grid-cols-2 gap-5">
        {REVIEWS.map((r, i) => (
          <motion.figure
            key={r.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: (i % 2) * 0.12, ease: EASE }}
            className="group relative rounded-3xl bg-white border border-slate-200/80 p-8 hover:shadow-[0_30px_60px_rgba(11,25,44,0.10)] hover:-translate-y-1 transition-all duration-500"
          >
            <Quote className="absolute top-7 right-7 h-9 w-9 text-amber-400/20 transition-colors duration-500 group-hover:text-amber-400/40" />
            <div className="flex gap-1">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} className="h-4 w-4 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <blockquote className="mt-5 text-base sm:text-lg leading-relaxed text-slate-700">
              “{r.text}”
            </blockquote>
            <figcaption className="mt-6 flex items-center gap-4 border-t border-slate-100 pt-5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#0B192C] font-display text-sm font-extrabold text-amber-400">
                {initials(r.name)}
              </span>
              <div>
                <p className="font-display font-bold text-[#0B192C]">{r.name}</p>
                <p className="flex items-center gap-1 text-xs font-semibold text-slate-500">
                  <MapPin className="h-3 w-3 text-amber-500" />
                  {r.city}
                </p>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
